'use client';
import {
  adminClient,
  emailOTPClient,
  inferAdditionalFields,
  magicLinkClient,
  anonymousClient,
} from 'better-auth/client/plugins';

import { createAuthClient } from 'better-auth/react';
import { type AuthAdditionalFields, getAuthBaseUrl } from '@sizzlenz/shared-frontend/auth';

// Cookie names are site-scoped (e.g. "sizzlenz.session_token") because the API sets
// Better Auth's cookiePrefix from SITE_ID. The site id is resolved from the
// environment (NEXT_PUBLIC_SITE_ID / SITE_ID / SIZZLE_PLATFORM) since this app
// serves more than one site. `createAuthClient` itself takes no cookie options —
// the browser handles the jar — so these are re-exported for code that needs to
// name the cookie directly.
export {
  getAuthCookieNames,
  getAuthCookiePrefix,
  getAuthSessionCookieName,
  getAuthSessionDataCookieName,
  hasAuthSessionCookie,
} from '@sizzlenz/shared-frontend/auth';

export const authClient = createAuthClient({
  baseURL: getAuthBaseUrl(),
  plugins: [
    anonymousClient(),
    adminClient(),
    magicLinkClient(),
    emailOTPClient(),
    inferAdditionalFields<AuthAdditionalFields>(),
  ],
  sessionOptions: {
    refetchOnWindowFocus: false,
  },
});

export const { signIn, signOut, signUp, getSession, useSession } = authClient;

// Magic link specific functions - using the available API
export const sendMagicLink = async (data: { email: string; redirectTo?: string }) => {
  // Use the signIn method with magic link
  return authClient.signIn.magicLink(data);
};

export const sendOTP = async (data: { email: string; redirectTo?: string }) => {
  return authClient.emailOtp.sendVerificationOtp({ email: data.email, type: 'sign-in' });
};

export const verifyMagicLink = async (data: { token: string }) => {
  return authClient.magicLink.verify(data);
};

export const signinOTP = async (data: { otp: string; email: string }) => {
  return authClient.signIn.emailOtp({ ...data });
};
